import { ContentStat } from "../../../../../models/state/contentStats";

export function getId(
  state: ContentStat | null | undefined
): string | null | undefined {
  return state ? state.contentId : null;
}

export function getTimesStudied(state: ContentStat | null | undefined): number {
  return state ? state.timesStudied : 0;
}

export function getLastStudied(
  state: ContentStat | null | undefined
): string | null | undefined {
  return state ? state.lastStudied : null;
}

export function getLastScore(
  state: ContentStat | null | undefined
): number | null | undefined {
  return state ? state.lastScore : null;
}

export function getLastContentModuleId(
  state: ContentStat | null | undefined
): string | null | undefined {
  return state ? state.lastContentModuleId : null;
}

export function lastTryWasIncorrect(
  state: ContentStat | null | undefined
): boolean {
  const lastScore = getLastScore(state);

  if (typeof lastScore === "number") {
    return lastScore < 1;
  }

  return false;
}
